// src/pages/VerifyPending.tsx
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function VerifyPending() {
  const { search } = useLocation();
  const nav = useNavigate();
  const { t } = useTranslation();

  const params = useMemo(() => new URLSearchParams(search), [search]);
  const email = params.get('email') || '';
  const redirectTo = params.get('redirectTo') || '/login';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="p-6 bg-white rounded-xl shadow w-full max-w-md text-center">
        <h1 className="text-xl font-semibold mb-2">
          {t('verify_pending.title') || '確認メールを送信しました'}
        </h1>
        <p className="text-gray-700">
          {t('verify_pending.desc', { email }) ||
            `${email ? `${email} 宛に` : ''} 認証用のリンクを送信しました。メール内のリンクをクリックして認証を完了してください。`}
        </p>
        <p className="text-gray-500 text-sm mt-2">
          {t('verify_pending.tip') ||
            'メールが届かない場合は迷惑メールをご確認ください。必要に応じて再送してください。'}
        </p>
        <div className="mt-6 flex gap-2 justify-center">
          <button
            onClick={() => nav(`/login?redirectTo=${encodeURIComponent(redirectTo)}`)}
            className="px-4 py-2 rounded-lg bg-coral text-white hover:opacity-90"
          >
            {t('verify_pending.to_login') || 'ログインへ'}
          </button>
          <button
            onClick={() => nav('/')}
            className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
          >
            {t('verify_pending.to_home') || 'トップへ'}
          </button>
        </div>
      </div>
    </div>
  );
}
